import Service from "./service"

const getAdministrativeCorrections = async ({ commit }: any) => {
  const data = (await Service().index()).data
  commit("save_administrative_corrections", data)
}

export default {
  getAdministrativeCorrections,
}
